import { Stocks_StockType } from '../../../__generated__/globalTypes';
import { Investment_IdeaType } from 'types/common';
import { SHOW_ORDER_SUBMITTED_MODAL, HIDE_ORDER_SUBMITTED_MODAL, Action } from 'actions';

export interface State {
  productType?: Stocks_StockType | Investment_IdeaType | null;
}

const initState: State = {};

export default function reducer(state: State = initState, action: Action): State {
  switch (action.type) {
    case SHOW_ORDER_SUBMITTED_MODAL:
      return {
        ...state,
        productType: action.payload.productType,
      };
    case HIDE_ORDER_SUBMITTED_MODAL:
      return initState;
    default:
      return state;
  }
}
